import { getHomePagePath, getTeamPagePath, getProjectsPagePath, getServicesPagePath, getContactsPagePath, getBlogPagePath, getDedicatedDevelopersPagePath, getProductsPagePath } from "./consts";

export const MAIN_NAVIGATION_LINKS = [
    { name: "Home", href: getHomePagePath(), prefetch: true, footer: true },
    { name: "Projects", href: getProjectsPagePath(), prefetch: false, footer: true },
    { name: "Services", href: getServicesPagePath(), prefetch: false, footer: true },
    { name: "Team", href: getTeamPagePath(), prefetch: true, footer: true },
    { name: "Contacts", href: getContactsPagePath(), prefetch: false, footer: true },
    { name: "Blog", href: getBlogPagePath(), prefetch: false, footer: true },
    { name: "Products", href: getProductsPagePath(), prefetch: false, footer: true, header: false },
    { name: "Navigation Lab", href: "/labs/navigation", prefetch: false, footer: true, header: false },
    { name: "Privacy Policy", href: "/privacy-policy", prefetch: false, footer: true, header: false },
];

export const HEADER_LINKS = [
    { label: "UData", href: getHomePagePath() },
    { label: "Dedicated developers", href: getDedicatedDevelopersPagePath() },
];

export const OUTSTAFF_NAVIGATION_LINKS = [
    { name: "How It Works", href: "#how-it-works" },
    { name: "Benefits", href: "#benefits" },
    { name: "Comparison Table", href: "#comparison-table" },
    { name: "Success Stories", href: "#success-stories" },
    { name: "Pricing", href: "#pricing" },
    { name: "FAQ", href: "#faq" },
];
